import styled from 'styled-components';

const AsideList = styled.div`
  .asideListItems {
    @media (min-width: 992px) {
      padding: 0 2rem;
    }
  }
`;

export default AsideList;
